<div class="setting-page">
  <div class="web-services">
    <legend>Web Services</legend>
    <div class="action-buttons">
      <arm-action-bar (addClick)="addWebService()" [disableAdd]="!canSubmit || !isFeatureSupported || isAddDisabled()"
                      (refreshClick)="refresh()" [disableRefresh]="!isFeatureSupported"
                      (deleteClick)="removeWebService()" [disableDelete]="!selection || !isFeatureSupported || !canSubmit"
                      (editClick)="editWebService()" [disableEdit]="!selection || !canSubmit || !isFeatureSupported">
      </arm-action-bar>
    </div>

    <div class="web-services-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)" [data]="implementations"
                 [isMultipleSelection]="false"
                 [isClientSide]="true"></arm-table>
    </div>
  </div>
</div>
